import { render, staticRenderFns } from "./DK.vue?vue&type=template&id=b2cd7596&"
import script from "./DK.js?vue&type=script&lang=js&"
export * from "./DK.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports